export const getABVariantParam = () => {
  const params = new URLSearchParams(window.location.search);
  const abVariationParam = params.get('variant');
  const existingVariant = localStorage.getItem('homepage_variant_override');

  if (abVariationParam) {
    return abVariationParam;
  }

  if (existingVariant) {
    return existingVariant;
  }

  return 'B';
};

export const setABParameter = () => {
  const variantValue = getABVariantParam();
  localStorage.setItem('homepage_variant_override', variantValue);

  return variantValue;
};
